import { Tooltip, TooltipProps, withStyles } from "@material-ui/core";
import React from "react";
import { tesaDark, tesaWhite } from "../../styles/colors";

const TesaThemedTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: tesaDark,
    color: tesaWhite,
    fontSize: theme.typography.pxToRem(14),
    border: "none",
    borderRadius: 0,
    padding: "8px 16px",
  },
}))(Tooltip);

const StyledTooltip: React.FC<TooltipProps> = (props) => {
  const { children } = props;

  return (
    <TesaThemedTooltip leaveDelay={200} enterDelay={600} enterNextDelay={600} {...props}>
      {children}
    </TesaThemedTooltip>
  );
};

export default StyledTooltip;
